@if (display) {
  <p-dialog [styleClass]="authenticationService?.user?.fontSize === 'SMALL' ? 'custom-form-small' : (authenticationService?.user?.fontSize === 'MEDIUM' ? 'custom-form-medium' : '')" header="{{ title | uppercase }}" [(visible)]="display" showEffect="fade" [modal]="true"
    [style]="{ width: '1150px' }"
    appendTo="body">
<div [ngClass]="{'custom-form-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-form-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
    <!-- #region BODY -->
    <div class="d-flex flex-column gap-3 p-3">
      <div #errorContainer>
        @if (errorMessages.length !== 0) {
          <div>
            @for (error of errorMessages; track error) {
              <div>
                <div class='alert alert-warning' role='alert'>{{error}}</div>
              </div>
            }
          </div>
        }
      </div>
      <!-- CONTRACT DATA PANEL -->
      <p-panel header="{{ 'drivers.form.contractData' | translate }}" [toggleable]="true" class="w-100">
        <!-- FINANCING TYPE & PROVIDER & CONTRACT -->
        <div class="row mt-3">
          <!-- FINANCING TYPE Input -->
          <div class="col-md-4">
            <div class="row">
              <div class="col-12">
                <label for="financing-type" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
								<strong>{{ 'tableManagement.financing.financingType' | translate }} (*)</strong>
							</label>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <p-select [options]="financeTypeList" [(ngModel)]="entity.financingType"
                  [placeholder]="financeTypePlaceholder" dataKey="id" optionLabel="name"
                  [style]="{ width: '100%' }" appendTo="body" [filter]="true" filterBy="name"
                  (onChange)="onChangeFinanceType($event)" (onFilter)="onFilterFinanceType($event)"
                  (ngModelChange)="ownVehicle = $event?.ownVehicle || false"
                  [disabled]="saving || !formManipulation">
                </p-select>
              </div>
            </div>
          </div>
          <!-- PROVIDER Input -->
          <div class="col-md-4">
            <div class="row">
              <div class="col-12">
                <label for="provider" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
								<strong>{{ 'tableManagement.providers.provider' | translate }} (*)</strong>
							</label>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <p-select [options]="providerList " [(ngModel)]="provider"
                  [placeholder]="providerPlaceholder" dataKey="id" optionLabel="name"
                  [style]="{ width: '100%' }" appendTo="body" [filter]="true" filterBy="name"
                  (onChange)="onChangeProvider($event)" (onFilter)="onFilterProvider($event)" [disabled]="saving || !formManipulation">
                </p-select>
              </div>
            </div>
          </div>
          <!-- CONTRACT Input -->
          <div class="col-md-4">
            <label for="contract" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						<strong>{{'tableManagement.financing.contract' | translate}} (*)</strong>
					</label>
            <input type="text" id="contract" class="form-control custom-input" [(ngModel)]="entity.contract"
              [disabled]="saving || !formManipulation" />
          </div>
        </div>
        <!-- INTEREST RATE & START DATE & END DATE -->
        <div class="row mt-3">
          <!-- INTEREST RATE Input -->
          <div class="col-md-4">
            <label for="interest-rate" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						{{'tableManagement.financing.interestRate' | translate}}
					</label>
            <div class="p-0"></div>
            <div class="input-wrapper" style="width: 100%;">
              <p-inputNumber [showButtons]="false" [style]="{ width: '100%' }" [(ngModel)]="entity.interestRate" mode="decimal" locale="es-ES"
                (onKeyDown)="onKeyDownDecimal($event)"
              [disabled]="saving || !formManipulation" [maxFractionDigits]="6"></p-inputNumber>
              <span class="input-symbol">%</span>
            </div>
          </div>
          <!-- START DATE Input -->
          <div class="col-md-4">
            <div class="row">
              <div class="col-12">
                <label for="start-date" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
								<!-- If the ownVehicle is set to true will show the first translation -->
								<strong>{{ ownVehicle ? ('general.buyDate' | translate) : ('general.startDate' |
									translate) }} (*)</strong>
							</label>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <p-datepicker [(ngModel)]="startDateFinancing" id="start-date" [showTime]="false"
                  [style]="{ width: '100%' }" dateFormat='{{i18n.dateFormat}}' showIcon="true" appendTo="body"
                [disabled]="saving || !formManipulation"></p-datepicker>
              </div>
            </div>
          </div>
          <!-- END DATE Input -->
          <div class="col-md-4">
            <div class="row">
              <div class="col-12">
                <label for="end-date" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
								{{ 'general.endDate' | translate }}
							</label>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <p-datepicker [(ngModel)]="endDateFinancing" id="end-date" [showTime]="false"
                  [style]="{ width: '100%' }" dateFormat='{{i18n.dateFormat}}' showIcon="true" appendTo="body"
                [disabled]="ownVehicle || saving || !formManipulation"></p-datepicker>
              </div>
            </div>
          </div>
        </div>
        <!-- CONTRACT TYPE & EFFECTIVE DATE & CONTRACT KM -->
        <div class="row mt-3">
          <!-- CONTRACT TYPE Input -->
          <div class="col-md-4">
            <div class="row">
              <div class="col-12">
                <label for="contract-type" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
								<!-- If the ownVehicle is set to true will show the first translation -->
								{{ 'tableManagement.financing.contractType.label' | translate }} (*)
							</label>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <p-select [options]="contractTypeList" [(ngModel)]="entity.contractType"
                  [placeholder]="contractTypePlaceholder"
                  [style]="{ width: '100%' }" appendTo="body" [disabled]="saving || !formManipulation">
                </p-select>
              </div>
            </div>
          </div>
          <!-- EFFECTIVE DATE Input -->
          <div class="col-md-4">
            <div class="row">
              <div class="col-12">
                <label for="effective-date" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
								{{ 'tableManagement.financing.effectiveDate' | translate }}
							</label>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <p-datepicker [(ngModel)]="effectiveDate" id="effective-date" [showTime]="false"
                  [style]="{ width: '100%' }" dateFormat='{{i18n.dateFormat}}' showIcon="true" appendTo="body"
                [disabled]="saving || !formManipulation"></p-datepicker>
              </div>
            </div>
          </div>
        </div>
        <!-- IMPORT SERVICE / IMPORT FINANCING / TOTAL IMPORT -->
        @if (isExtraGranted) {
          <div class="row mt-3">
            <!-- IMPORT SERVICE Input -->
            <div class="col-md-4">
              <label for="import-service" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
							{{'tableManagement.financing.importService' | translate}}
						</label>
              <div class="input-wrapper" style="width: 100%;">
                <p-inputNumber [showButtons]="false" [style]="{ width: '100%' }" [(ngModel)]="entity.importService" mode="decimal" locale="es-ES"
                  (onKeyDown)="onKeyDownDecimal($event)"
                [disabled]="saving || !formManipulation"></p-inputNumber>
                <span class="input-symbol">€</span>
              </div>
            </div>
            <!-- IMPORT FINANCING Input -->
            <div class="col-md-4">
              <label for="import-financing" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
							{{'tableManagement.financing.importFinancing' | translate}}
						</label>
              <div class="input-wrapper" style="width: 100%;">
                <p-inputNumber [showButtons]="false" [style]="{ width: '100%' }" [(ngModel)]="entity.importFinancing" mode="decimal" locale="es-ES"
                  (onKeyDown)="onKeyDownDecimal($event)"
                [disabled]="saving || !formManipulation"></p-inputNumber>
                <span class="input-symbol">€</span>
              </div>
            </div>
            <!-- TOTAL IMPORT Input -->
            <div class="col-md-4">
              <label for="total-import" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
							{{'tableManagement.financing.totalImport' | translate}}
						</label>
              <div class="input-wrapper" style="width: 100%;">
                <p-inputNumber [showButtons]="false" [style]="{ width: '100%' }" [(ngModel)]="entity.totalImport" mode="decimal" locale="es-ES"
                  (onKeyDown)="onKeyDownDecimal($event)"
                [disabled]="saving || !formManipulation"></p-inputNumber>
                <span class="input-symbol">€</span>
              </div>
            </div>
          </div>
        }
        <!-- CONTRACT KM & MONTHLY FEE -->
        <div class="row mt-3">
          <!-- CONTRACT KM Input -->
          <div class="col-md-4">
            <label for="contract-km" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						{{'tableManagement.financing.contractKms' | translate}}
					</label>
            <div class="input-wrapper" style="width: 100%;">
              <!-- Display this input when showValues is true -->
              @if (showValues) {
                <p-inputNumber [showButtons]="false" [style]="{ width: '100%' }" [(ngModel)]="entity.contractKm" mode="decimal" locale="es-ES"
                  (onKeyDown)="onKeyDownDecimal($event)"
                [disabled]="saving || !formManipulation"></p-inputNumber>
              }
              <!-- Display this input when showValues is false -->
              @if (!showValues) {
                <p-inputNumber [showButtons]="false" [style]="{ width: '100%' }" [ngModel]="''" mode="decimal" locale="es-ES"
                (onKeyDown)="onKeyDownDecimal($event)" [disabled]="true"></p-inputNumber>
              }
              <span class="input-symbol">km</span>
            </div>
          </div>
        </div>
        <!-- MONTHLY FEE & INVESTMENT COST & EXCESS COST -->
        <div class="row mt-3">
          <!-- MONTHLY FEE Input -->
          <div class="col-md-4">
            <label for="monthly-fee" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						{{ (isExtraGranted ? 'tableManagement.financing.totalPlusVat' : 'tableManagement.financing.monthlyFee') | translate}}
					</label>
            <div class="input-wrapper" style="width: 100%;">
              <!-- Display this input when showValues is true -->
              @if (showValues) {
                <p-inputNumber [showButtons]="false" [style]="{ width: '100%' }" [(ngModel)]="entity.monthlyFee" mode="decimal" locale="es-ES"
                  (onKeyDown)="onKeyDownDecimal($event)"
                [disabled]="saving || !formManipulation"></p-inputNumber>
              }
              <!-- Display this input when showValues is false -->
              @if (!showValues) {
                <p-inputNumber [showButtons]="false" [style]="{ width: '100%' }" [ngModel]="''" mode="decimal" locale="es-ES"
                (onKeyDown)="onKeyDownDecimal($event)" [disabled]="true"></p-inputNumber>
              }
              <span class="input-symbol">€</span>
            </div>
          </div>
          <!-- INVESTMENT COST Input -->
          <div class="col-md-4">
            <label for="investment-cost" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						{{ ownVehicle ? ('tableManagement.financing.buyingCost' | translate) :
						('tableManagement.financing.investmentCost' | translate)}}
					</label>
            <div class="input-wrapper" style="width: 100%;">
              @if (showValues) {
                <p-inputNumber [showButtons]="false" [style]="{ width: '100%' }" [(ngModel)]="entity.investmentCost" mode="decimal"
                  locale="es-ES" (onKeyDown)="onKeyDownDecimal($event)"
                [disabled]="saving || !formManipulation" ></p-inputNumber>
              }
              @if (!showValues) {
                <p-inputNumber [showButtons]="false" [style]="{ width: '100%' }" [ngModel]="''" mode="decimal" locale="es-ES"
                (onKeyDown)="onKeyDownDecimal($event)" [disabled]="true" ></p-inputNumber>
              }
              <span class="input-symbol">€</span>
            </div>
          </div>
          <!-- EXCESS COST Input -->
          <div class="col-md-4">
            <label for="excess-cost" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						{{'tableManagement.financing.excessCost' | translate}}
					</label>
            <div class="input-wrapper" style="width: 100%;">
              @if (showValues) {
                <p-inputNumber [showButtons]="false" [style]="{ width: '100%' }" [(ngModel)]="entity.excessCost" mode="decimal" locale="es-ES"
                  (onKeyDown)="onKeyDownDecimal($event)"
                [disabled]="saving || !formManipulation" [maxFractionDigits]="6"></p-inputNumber>
              }
              @if (!showValues) {
                <p-inputNumber [showButtons]="false" [style]="{ width: '100%' }" [ngModel]="''" mode="decimal" locale="es-ES"
                (onKeyDown)="onKeyDownDecimal($event)" [disabled]="true" [maxFractionDigits]="6"></p-inputNumber>
              }
              <span class="input-symbol">€</span>
            </div>
          </div>
        </div>
        <!-- DEFAULT COST -->
        <div class="row mt-3">
          <div class="col-md-4">
            <label for="investment-cost" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						{{ 'tableManagement.financing.defaultCost' | translate }}
					</label>
            <div class="input-wrapper" style="width: 100%;">
              @if (showValues) {
                <p-inputNumber [showButtons]="false" [style]="{ width: '100%' }" [(ngModel)]="entity.unrealizedKmCost" mode="decimal"
                  locale="es-ES" (onKeyDown)="onKeyDownDecimal($event)"
                [disabled]="saving || !formManipulation" [maxFractionDigits]="6"></p-inputNumber>
              }
              @if (!showValues) {
                <p-inputNumber [showButtons]="false" [style]="{ width: '100%' }" [ngModel]="''" mode="decimal" locale="es-ES"
                (onKeyDown)="onKeyDownDecimal($event)" [disabled]="true" [maxFractionDigits]="6"></p-inputNumber>
              }
              <span class="input-symbol">€</span>
            </div>
          </div>
        </div>
      </p-panel>
      <!-- FINANCING DATA PANEL -->
      <p-panel header="{{ 'drivers.form.contabilityData' | translate }}" [toggleable]="true" class="w-100">
        <!-- PFF VALUE & OPTIONS VALUE & EXTRAS VALUE -->
        <div class="row mt-3">
          <!-- PFF VALUE Input -->
          <div class="col-md-4">
            <label for="pff-value" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						{{'tableManagement.financing.pffValue' | translate}}
					</label>
            <div class="input-wrapper" style="width: 100%;">
              @if (showValues) {
                <p-inputNumber [showButtons]="false" [style]="{ width: '100%' }" [(ngModel)]="entity.pffValue" mode="decimal" locale="es-ES"
                  (onKeyDown)="onKeyDownDecimal($event)" (ngModelChange)="onValuesChange()"
                [disabled]="saving || !formManipulation"></p-inputNumber>
              }
              @if (!showValues) {
                <p-inputNumber [showButtons]="false" [style]="{ width: '100%' }" [ngModel]="''" mode="decimal" locale="es-ES"
                (onKeyDown)="onKeyDownDecimal($event)" [disabled]="true"></p-inputNumber>
              }
              <span class="input-symbol">€</span>
            </div>
          </div>
          <!-- OPTIONS VALUE Input -->
          <div class="col-md-4">
            <label for="options-value" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						{{'tableManagement.financing.optionsValue' | translate}}
					</label>
            <div class="input-wrapper" style="width: 100%;">
              @if (showValues) {
                <p-inputNumber [showButtons]="false" [style]="{ width: '100%' }" [(ngModel)]="entity.optionsValue" mode="decimal"
                  locale="es-ES" (onKeyDown)="onKeyDownDecimal($event)" (ngModelChange)="onValuesChange()"
                [disabled]="saving || !formManipulation"></p-inputNumber>
              }
              @if (!showValues) {
                <p-inputNumber [showButtons]="false" [style]="{ width: '100%' }" [ngModel]="''" mode="decimal" locale="es-ES"
                (onKeyDown)="onKeyDownDecimal($event)" [disabled]="true"></p-inputNumber>
              }
              <span class="input-symbol">€</span>
            </div>
          </div>
          <!-- EXTRAS VALUE Input -->
          <div class="col-md-4">
            <label for="extras-value" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						{{'tableManagement.financing.extrasValue' | translate}}
					</label>
            <div class="input-wrapper" style="width: 100%;">
              @if (showValues) {
                <p-inputNumber [showButtons]="false" [style]="{ width: '100%' }" [(ngModel)]="entity.extrasValue" mode="decimal" locale="es-ES"
                  (onKeyDown)="onKeyDownDecimal($event)" (ngModelChange)="onValuesChange()"
                [disabled]="saving || !formManipulation"></p-inputNumber>
              }
              @if (!showValues) {
                <p-inputNumber [showButtons]="false" [style]="{ width: '100%' }" [ngModel]="''" mode="decimal" locale="es-ES"
                (onKeyDown)="onKeyDownDecimal($event)" [disabled]="true"></p-inputNumber>
              }
              <span class="input-symbol">€</span>
            </div>
          </div>
        </div>
        <!-- TAX BASE VALUE & VAT & VAT VALUE -->
        <div class="row mt-3">
          <!-- TAX BASE VALUE Input -->
          <div class="col-md-4">
            <label for="tax-base-value" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						{{'tableManagement.financing.taxBaseValue' | translate}}
					</label>
            <div class="input-wrapper" style="width: 100%;">
              @if (showValues) {
                <p-inputNumber [showButtons]="false" [style]="{ width: '100%' }" [(ngModel)]="entity.taxBaseValue" mode="decimal"
                  locale="es-ES" (onKeyDown)="onKeyDownDecimal($event)" (ngModelChange)="onValuesChange()"
                [disabled]="true"></p-inputNumber>
              }
              @if (!showValues) {
                <p-inputNumber [showButtons]="false" [style]="{ width: '100%' }" [ngModel]="''" mode="decimal" locale="es-ES"
                (onKeyDown)="onKeyDownDecimal($event)" [disabled]="true"></p-inputNumber>
              }
              <span class="input-symbol">€</span>
            </div>
          </div>
          <!-- VAT Input -->
          <div class="col-md-4">
            <label for="vat" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						{{ 'tableManagement.financing.vat' | translate }}
					</label>
            <div class="input-wrapper" style="width: 100%;">
              @if (showValues) {
                <p-inputNumber [showButtons]="false" [style]="{ width: '100%' }" [(ngModel)]="vatPercentage" mode="decimal" locale="es-ES"
                  (onKeyDown)="onKeyDownDecimal($event)" (ngModelChange)="onValuesChange()"
                [disabled]="saving || !formManipulation"></p-inputNumber>
              }
              @if (!showValues) {
                <p-inputNumber [showButtons]="false" [style]="{ width: '100%' }" [ngModel]="''" mode="decimal" locale="es-ES"
                (onKeyDown)="onKeyDownDecimal($event)" [disabled]="true"></p-inputNumber>
              }
              <span class="input-symbol">%</span>
            </div>
          </div>
          <!-- VAT VALUE Input -->
          <div class="col-md-4">
            <label for="vat-value" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						{{ 'tableManagement.financing.vatValue' | translate }}
					</label>
            <div class="input-wrapper" style="width: 100%;">
              @if (showValues) {
                <p-inputNumber [showButtons]="false" [style]="{ width: '100%' }" [(ngModel)]="entity.vatValue" mode="decimal" locale="es-ES"
                  (onKeyDown)="onKeyDownDecimal($event)" (ngModelChange)="onValuesChange()"
                [disabled]="true"></p-inputNumber>
              }
              @if (!showValues) {
                <p-inputNumber [showButtons]="false" [style]="{ width: '100%' }" [ngModel]="''" mode="decimal" locale="es-ES"
                (onKeyDown)="onKeyDownDecimal($event)" [disabled]="true"></p-inputNumber>
              }
              <span class="input-symbol">€</span>
            </div>
          </div>
        </div>
        <!-- TOTAL VALUE -->
        <div class="row mt-3">
          <!-- TOTAL VALUE Input -->
          <div class="col-md-4">
            <label for="total-value" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						{{'tableManagement.financing.totalValue' | translate}}
					</label>
            <div class="input-wrapper" style="width: 100%;">
              @if (showValues) {
                <p-inputNumber [showButtons]="false" [style]="{ width: '100%' }" [(ngModel)]="entity.totalValue" mode="decimal" locale="es-ES"
                  (onKeyDown)="onKeyDownDecimal($event)" (ngModelChange)="onValuesChange()"
                [disabled]="true"></p-inputNumber>
              }
              @if (!showValues) {
                <p-inputNumber [showButtons]="false" [style]="{ width: '100%' }" [ngModel]="''" mode="decimal" locale="es-ES"
                (onKeyDown)="onKeyDownDecimal($event)" [disabled]="true"></p-inputNumber>
              }
              <span class="input-symbol">€</span>
            </div>
          </div>
        </div>
      </p-panel>
      <!-- VEHICLE AND COMPLEMENTARY DATA PANEL -->
      <p-panel header="{{ 'drivers.form.financingData' | translate }}" [toggleable]="true" class="w-100">
        <!-- VEHICLE & REPLACED VEHICLE & BUY BACK VALUE -->
        <div class="row mt-3">
          <!-- VEHICLE Input -->
          <div class="col-md-4">
            <div class="row">
              <div class="col-12">
                <label for="vehicle" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
								{{ 'tableManagement.vehicle.vehicle' | translate }}
							</label>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <p-select [options]="vehicleList" [(ngModel)]="entity.vehicle"
								[disabled]="vehicle || saving || !formManipulation" placeholder="{{ 'general.select' | translate }} {{
									'tableManagement.vehicle.vehicle' | translate
								}}" dataKey="id" optionLabel="name" [style]="{ width: '100%' }" appendTo="body" [filter]="true"
                  filterBy="name" (onChange)="onChangeVehicle($event)"
                  (onFilter)="onFilterVehicle($event)">
                </p-select>
              </div>
            </div>
          </div>
          <!-- REPLACED VEHICLE Input -->
          <div class="col-md-4">
            <div class="row">
              <div class="col-12">
                <label for="replaced-vehicle" class="form-label custom-label fw-bold small mb-2 me-2" i18n>{{
								'tableManagement.financing.replacedVehicle2' | translate }}
							</label>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <p-select [options]="replacedVehicleList" [(ngModel)]="entity.replacedVehicle"
								placeholder="{{ 'general.select' | translate }} {{
									'tableManagement.vehicle.vehicle' | translate
								}}" dataKey="id" optionLabel="name" [style]="{ width: '100%' }" appendTo="body" [filter]="true"
                  filterBy="name" (onChange)="onChangeReplacedVehicle($event)" [showClear]="true"
                  (onFilter)="onFilterReplacedVehicle($event)" [disabled]="saving || !formManipulation">
                </p-select>
              </div>
            </div>
          </div>
          <!-- BUY BACK VALUE Input -->
          <div class="col-md-4">
            <label for="buyback-value" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						{{'tableManagement.financing.buybackValue' | translate}}
					</label>
            <div class="input-wrapper" style="width: 100%;">
              @if (showValues) {
                <p-inputNumber [showButtons]="false" [style]="{ width: '100%' }" [(ngModel)]="entity.buyBackValue" mode="decimal"
                  locale="es-ES" (onKeyDown)="onKeyDownDecimal($event)"
                [disabled]="saving || !formManipulation"></p-inputNumber>
              }
              @if (!showValues) {
                <p-inputNumber [showButtons]="false" [style]="{ width: '100%' }" [ngModel]="''" mode="decimal" locale="es-ES"
                (onKeyDown)="onKeyDownDecimal($event)" [disabled]="true"></p-inputNumber>
              }
              <span class="input-symbol">€</span>
            </div>
          </div>
        </div>
        <!-- KM ADJUSTMENT & WAY TO PAY & RENTING TYPE -->
        <div class="row mt-3">
          <!-- KM ADJUSTMENT Input -->
          <div class="col-md-4">
            <label for="km-adjustment" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						{{'tableManagement.financing.kmAdjustment' | translate}}
					</label>
            <div class="input-wrapper" style="width: 100%;">
              @if (showValues) {
                <p-inputNumber [showButtons]="false" [style]="{ width: '100%' }" [(ngModel)]="entity.kmAdjustment" mode="decimal"
                  locale="es-ES" (onKeyDown)="onKeyDownDecimal($event)"
                [disabled]="saving || !formManipulation"></p-inputNumber>
              }
              @if (!showValues) {
                <p-inputNumber [showButtons]="false" [style]="{ width: '100%' }" [ngModel]="''" mode="decimal" locale="es-ES"
                (onKeyDown)="onKeyDownDecimal($event)" [disabled]="true"></p-inputNumber>
              }
              <span class="input-symbol">€</span>
            </div>
          </div>
          <!-- WAY TO PAY Input -->
          <div class="col-md-4">
            <div class="row">
              <div class="col-12">
                <label for="way-to-pay" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
								<strong>{{ 'tableManagement.wayToPay.wayToPay' | translate }} (*)</strong>
							</label>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <p-select [options]="wayToPayList" [ngModel]="entity.wayToPay"
                  [placeholder]="wayToPayPlaceholder" dataKey="id" optionLabel="name"
                  [style]="{ width: '100%' }" appendTo="body" [filter]="true" filterBy="name"
                  (onChange)="onChangeWayToPay($event)" (onFilter)="onFilterWayToPay($event)"
                  [disabled]="saving || !formManipulation">
                </p-select>
              </div>
            </div>
          </div>
          <!-- RENTING TYPE Input -->
          <div class="col-md-4">
            <div class="row">
              <div class="col-12">
                <label for="renting-type" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
								{{ 'tableManagement.rentingTypes.rentingType' | translate }}
							</label>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <p-select [options]="rentingTypeList" [ngModel]="entity.rentingType"
                  [placeholder]="rentingTypePlaceholder" dataKey="id" optionLabel="name"
                  [style]="{ width: '100%' }" appendTo="body" [filter]="true"
                  [disabled]="ownVehicle || saving || !formManipulation" filterBy="name"
                  (onChange)="onChangeRentingType($event)" (onFilter)="onFilterRentingType($event)">
                </p-select>
              </div>
            </div>
          </div>
        </div>
        <!-- OBSERVATIONS -->
        <div class="row mt-3">
          <div class="col-12">
            <label for="observations" class="form-label custom-label fw-bold small mb-2 me-2 d-block" i18n>{{ 'general.observations' | translate }}</label>
            <textarea rows="2" cols="80" pInputTextarea [pTooltip]="entity.observations" tooltipPosition="top"
              [(ngModel)]="entity.observations" class="observations w-100" fitContent="true"
            [disabled]="saving || !formManipulation"></textarea>
          </div>
        </div>
      </p-panel>
      <p-panel header="{{ 'drivers.form.cancelationData' | translate }}" [toggleable]="true" class="w-100">
        <!-- CANCELATION DATE & CANCELATION KM & CANCELATION VALUE -->
        @if (!ownVehicle) {
          <div class="row mt-3">
            <!-- CANCELATION DATE Input -->
            <div class="col-md-4">
              <div class="row">
                <div class="col-12">
                  <label for="cancelation-date" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
								{{ 'tableManagement.financing.cancelationDate' | translate }}
							</label>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <p-datepicker [(ngModel)]="cancellationDateFinancing" id="cancelation-date" [showTime]="false"
                    [style]="{ width: '100%' }" dateFormat='{{i18n.dateFormat}}' showIcon="true" appendTo="body"
                  [disabled]="saving || !formManipulation"></p-datepicker>
                </div>
              </div>
            </div>
            <!-- CANCELATION KM Input -->
            <div class="col-md-4">
              <label for="cancellation-km" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						{{ 'tableManagement.financing.cancelationKm' | translate }}
					</label>
              <div class="input-wrapper">
                <input type="number" id="cancellation-km" class="form-control custom-input"
                  [(ngModel)]="entity.cancellationKm" [disabled]="savingv || !formManipulation" />
                <span class="input-symbol">km</span>
              </div>
            </div>
            <!-- CANCELATION VALUE Input -->
            <div class="col-md-4">
              <label for="cancelation-value" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						{{'tableManagement.financing.cancelationValue' | translate}}
					</label>
              <div class="input-wrapper" style="width: 100%;">
                <p-inputNumber [showButtons]="false" [style]="{ width: '100%' }" [(ngModel)]="entity.cancellationValue" mode="decimal" locale="es-ES"
                  (onKeyDown)="onKeyDownDecimal($event)"
                [disabled]="saving || !formManipulation"></p-inputNumber>
                <span class="input-symbol">€</span>
              </div>
            </div>
          </div>
        }
        <!-- AMORTIZATION PERIOD -->
        @if (ownVehicle) {
          <div class="row mt-3">
            <div class="col-md-4">
              <label for="amortization-period" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						{{ 'tableManagement.financing.amortizationPeriod' | translate }}
					</label>
              <input type="number" id="amortization-period" class="form-control custom-input"
                [(ngModel)]="entity.amortizationPeriod" [disabled]="saving || !formManipulation" />
            </div>
          </div>
        }
      </p-panel>
      <!-- ACTIVE Input -->
      <div class="row mt-3">
        <div class="col-md-auto d-flex align-items-center">
          <label for="fine-enabled" class="me-2" i18n>
					{{ 'general.active' | translate }}
				</label>
          <div class="form-check">
            <input class="form-check-input custom-checkbox" type="checkbox" [(ngModel)]="active"
              [disabled]="true" />
          </div>
        </div>
      </div>
      <!-- FILE -->
      <!-- <div class="row mt-3"> -->
      <!-- FILE NAME Input -->
      <!-- <div class="col-md-6">
      <label for="nombre document" class="custom-label" i18n>{{'tableManagement.financing.documentName' |
      translate}}</label>
      <input type="text" id="contract" class="form-control custom-input" [ngModel]="entity.document?.name"
        (ngModelChange)="onDocumentNameChange($event)">
    </div> -->
    <!-- FILE SELECT Input -->
    <!-- <div class="col-md-6">
    <label for="nombre document" class="custom-label" i18n></label>
    <input #uploadFileInput type="file" class="file-upload" (change)='onFileSelected($event)'>
  </div>
</div> -->
<!-- taula de documents -->
@if (!isNew) {
  <div class="row mt-3">
    <app-doc-table type="financing" [entity]="entity" [nested]="true" [ids]="ids" (return)="refresh()">
    </app-doc-table>
  </div>
}
</div>
<!-- #endregion BODY -->
</div>
<!-- #region FOOTER -->
<ng-template pTemplate="footer">
  <div class="d-flex justify-content-center bd-highlight">
    <div class="p-2 bd-highlight">
      @if (isNew) {
        <div>
          <button class="btn custom-button" (click)="saveChanges()" i18n
            [disabled]="saving || !formManipulation">
						{{ saving ? ('general.saving' | translate) : ('general.create' | translate) }}
					</button>
        </div>
      }
      @if (!isNew) {
        <div>
          <button class="btn custom-button" (click)="saveChanges()" i18n
            [disabled]="saving || !formManipulation">
						{{ saving ? ('general.saving' | translate) : ('general.save' | translate) }}
					</button>
        </div>
      }
    </div>
    <div class="p-2 bd-highlight">
      @if (!isNew) {
        <div>
          <button class="btn custom-button" (click)="changeStatus(!entity.disabled)" i18n
            [disabled]="saving || !formManipulation">
						{{ 'general.changeStatus' | translate }}
					</button>
        </div>
      }
    </div>
  </div>
</ng-template>
<!-- #endregion FOOTER -->
</p-dialog>
}

<!-- CONFIRM SAVE EVENT DIALOG -->
<p-confirmDialog appendTo="body" #missingFieldsDialog [header]=" 'confirm.critic' | translate "
  icon='pi pi-exclamation-triangle'>
  <ng-template pTemplate="footer">
    <button (click)="missingFieldsDialog.onAccept()" class="custom-button">
      OK
    </button>
  </ng-template>
</p-confirmDialog>